<template>
 <transition 
    v-if="showConfirmModal" 
    name="modal"
  >
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header d-flex align-items-center justify-content-between">
            <h4 class="modal-title">
              {{ data[type].title }}
            </h4>

            <img
              :src="asset('/images/side-menu/close.png')"
              width="30px"
              class="cursor-pointer"
              @click="closeModal"
            >
          </div>

          <div class="modal-body">
            <div>{{ data[type].body }}</div>
            <div class="mt-2 mt-xxl-4 d-flex justify-content-between">
              <div
                class="btn btn-success btn-lg btn-block w-48 close-btn"
                @click="closeModal"
              >
                OK
              </div>

              <div
                v-if="type === 'postRegister'"
                class="btn btn-success btn-lg btn-block resend-btn w-48"
                @click="resendEmail"
              >
                Resend Email
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ResetEmail',

  props: {
    show: {
      type: Number,
      default: 0
    },
  },

  data: function () {
    return {
      type: new URLSearchParams(window.location.search).get('type') || 'resetPassword',
      data: {
        register: {
          title: 'Thanks',
          body: 'Your email address has been verified'
        },
        resetEmail: {
          title: 'Done!',
          body: 'Please sign it to use the app.'
        }, 
        resetPassword: {
          title: 'Done!',
          body: 'Please sign it to use the app.'
        }, 
        postRegister: {
          title: 'Check your email!',
          body: 'We have sent a verification email to complete the registration process. Check your junk or spam folder if you don’t see it soon.'
        },
        invalid: {
          title: 'Link is invalid',
          body: 'This link is no longer valid.'
        }
      },
      caller: axios,
      email: '',
      newEmail: '',
      newEmailRepeat: '',
      showConfirmModal: this.show,
      errors: {},
    }
  },

  mounted() {
    if (this.type === 'register') {
      this.caller({
        url: window.rootPath + '/confirm',
        method: 'POST',
        data: {
          user_id: new URLSearchParams(window.location.search).get('user_id')
        }
      })
    }
  },

  methods: {
    closeModal() {
      let url = new URL(window.location.href);
      url.searchParams.set('showConfirmModal', '0');
      window.history.replaceState(null, null, url);
      this.showConfirmModal = false;
    },

    resendEmail() {
      this.caller({
        url: window.rootPath + '/resendEmail',
        method: 'POST',
        data: {
          user_id: new URLSearchParams(window.location.search).get('user_id')
        }
      })
      .then(function (response) {
        window.location.reload();
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.resend-btn {
  margin-top: 0;
}

.modal-title {
  font-size: 28px;
  font-weight: 400;
}

.modal-body {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 19px;
  line-height: 25px;
}


</style>